export const general = (type, data = {}) => ({
  type,
  props: {
    ...(data || {}),
  },
});
